import { useRef, useState } from "react";
import Modal from "../../components/ui/Modal";
import { StatusMessage } from "../../components/ui";
import PendingSitesForm from "../../components/forms/PendingSitesForm";
import type { PendingAction, PendingWorkflow } from "./pendingSites";

interface Props {
    workflow: PendingWorkflow;
    submitting: boolean;
    error: string | null;
    onSubmit: (items: PendingAction[]) => Promise<void>;
    onRemove: (key: string) => void;
    onCancel: () => void;
}

export function PendingSitesEditor({ workflow, submitting, error, onSubmit, onRemove, onCancel }: Props) {
    const formRef = useRef<HTMLFormElement>(null);
    const [customerDialogOpen, setCustomerDialogOpen] = useState(false);
    const busy = submitting || customerDialogOpen;
    const verb = workflow.mode === "approve" ? "Approve" : "Reject";
    return (
        <Modal isOpen title={`${verb} ${workflow.bulk ? `${workflow.sites.length} Sites` : "Site"}`}
            headerClass={workflow.mode === "reject" ? "modal__header--danger" : undefined}
            closeOnOverlayClick={false} okButtonLoading={busy} cancelButtonLoading={busy}
            onConfirm={() => { if (!busy) formRef.current?.requestSubmit(); }}
            onCancel={() => { if (!busy) onCancel(); }}
            content={<>
                {error && <StatusMessage kind="error">{error}</StatusMessage>}
                <PendingSitesForm formRef={formRef}
                    selectedSite={workflow.bulk ? null : workflow.sites[0]}
                    selectedSites={workflow.bulk ? workflow.sites : undefined}
                    mode={workflow.mode} isInsideModal
                    actionInFlight={submitting ? "pending-mutation" : null}
                    onCustomerDialogChange={setCustomerDialogOpen}
                    onApprove={(s, customerId) => onSubmit([{ s, customerId }])}
                    onReject={(s, customerId, reason) => onSubmit([{ s, customerId, reason }])}
                    onBulkApprove={onSubmit} onBulkReject={onSubmit}
                    onRemoveSelected={key => { if (!busy) onRemove(key); }} />
            </>}
        />
    );
}
